import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import {
  CheckBoxOffIcon,
  CheckBoxOnIcon,
  CraneIcon,
  EmptyContainerHandlerIcon,
  ForkLiftIcon,
  RailMountedGantryIcon,
  ReachStackerIcon,
  RubberTyredGantryIcon,
  StraddleCarrierIcon,
  TerminalTruckIcon,
} from '@tom-ui/ui'
import { EquipmentTypes } from '@yard/app/api'
import { useMemo } from 'react'

interface YardBlockSlotsContextMenuProps {
  open: boolean
  anchorPosition: { top: number; left: number } | undefined
  selectedEquipmentTypes?: EquipmentTypes[]
  onClose: () => void
  onSelect: (type: EquipmentTypes) => void
}

export const EquipmentTypesMenu = (props: YardBlockSlotsContextMenuProps) => {
  const { t } = useTranslate()
  const { open, anchorPosition, selectedEquipmentTypes, onClose, onSelect } = props

  const equipmentTypesOptions = useMemo(
    () => [
      {
        type: EquipmentTypes.Sts,
        label: t(EquipmentTypes.Sts),
        icon: <CraneIcon fontSize='small' />,
      },
      {
        type: EquipmentTypes.Rtg,
        label: t(EquipmentTypes.Rtg),
        icon: <RubberTyredGantryIcon fontSize='small' />,
      },
      {
        type: EquipmentTypes.Rs,
        label: t(EquipmentTypes.Rs),
        icon: <ReachStackerIcon fontSize='small' />,
      },
      {
        type: EquipmentTypes.Ech,
        label: t(EquipmentTypes.Ech),
        icon: <EmptyContainerHandlerIcon fontSize='small' />,
      },
      {
        type: EquipmentTypes.Tt,
        label: t(EquipmentTypes.Tt),
        icon: <TerminalTruckIcon fontSize='small' />,
      },
      {
        type: EquipmentTypes.Rmg,
        label: t(EquipmentTypes.Rmg),
        icon: <RailMountedGantryIcon fontSize='small' />,
      },
      {
        type: EquipmentTypes.Fl,
        label: t(EquipmentTypes.Fl),
        icon: <ForkLiftIcon fontSize='small' />,
      },
      {
        type: EquipmentTypes.Sc,
        label: t(EquipmentTypes.Sc),
        icon: <StraddleCarrierIcon fontSize='small' />,
      },
    ],
    [t],
  )

  return (
    <Menu
      open={open}
      onClose={onClose}
      anchorReference='anchorPosition'
      anchorPosition={anchorPosition}
    >
      {equipmentTypesOptions
        .sort((a, b) => a.label.localeCompare(b.label))
        .map(equipment => (
          <MenuItem
            key={equipment.type}
            onClick={() => {
              onSelect(equipment.type)
            }}
            className='nodrag'
          >
            <ListItemIcon sx={{ gap: 1 }}>
              {selectedEquipmentTypes?.includes(equipment.type) ? (
                <CheckBoxOnIcon fontSize='small' />
              ) : (
                <CheckBoxOffIcon fontSize='small' />
              )}
              {equipment.icon}
            </ListItemIcon>
            <ListItemText>{equipment.label}</ListItemText>
          </MenuItem>
        ))}
    </Menu>
  )
}
